export default __webpack_public_path__ + "static/media/1.cb8e0e88.png";